import styled from 'styled-components'

import { Button, Flex } from 'app/components/design-system-components'
import { KeyboardArrowRightRounded } from 'app/components/design-system-components/icons/hardware'
import KeyboardArrowLeftRounded from 'app/components/design-system-components/icons/hardware/KeyboardArrowLeftRounded'
import { Text } from 'app/components/design-system-components/typography'
import theme from 'app/match/applicationReportPDF/assets/theme'
import { DEFAULT_PAGINATION_LIMIT } from 'app/sm/team_viewing_preference/components/members_list'

type PaginationProps = {
  page: number
  setPage: (page: number) => void
  totalCount: number
  pageSize?: number
}

const PaginationContainer = styled(Flex)`
  display: flex;
  padding: ${(props) => props.theme.space[0]}px;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  min-width: fit-content;
  gap: ${(props) => props.theme.space[3]}px;
`

const ButtonText = styled.div`
  display: flex;
  align-items: center;
`

function Pagination({
  page,
  setPage,
  totalCount,
  pageSize = DEFAULT_PAGINATION_LIMIT,
}: PaginationProps) {
  const startIndex = page * pageSize - pageSize
  const endIndex =
    totalCount < page * pageSize ? totalCount - 1 : page * pageSize - 1

  const onClickPrevious = () => {
    if (page > 1) {
      setPage(page - 1)
    }
  }

  const onClickNext = () => {
    if ((page + 1) * pageSize - totalCount < pageSize) {
      setPage(page + 1)
    }
  }

  if (totalCount <= pageSize) {
    return <></>
  }

  return (
    <PaginationContainer>
      <Text
        as="span"
        m={0}
        p={0}
        fontSize={theme.fontSizes.pRegular14}
        color={theme.colors.gray600}
      >
        {startIndex + 1} to {endIndex + 1} of {totalCount} results
      </Text>
      <Flex>
        <Button
          onClick={onClickPrevious}
          variant="outlineGray"
          disabled={page <= 1}
          fontSize={theme.fontSizes.pRegular14}
          mr={5}
        >
          <ButtonText>
            <KeyboardArrowLeftRounded /> Previous
          </ButtonText>
        </Button>
        <Button
          onClick={onClickNext}
          variant="outlineGray"
          disabled={(page + 1) * pageSize >= totalCount + pageSize}
          fontSize={theme.fontSizes.pRegular14}
        >
          <ButtonText>
            Next <KeyboardArrowRightRounded />
          </ButtonText>
        </Button>
      </Flex>
    </PaginationContainer>
  )
}

export default Pagination
